import { useCallback, useState } from 'react'

import { useProductConfig } from '@/contexts/ProductConfigContext'

import { handleApiError } from '@/utils/apiErrorHandler'

import { callProductApi } from '@/config/productApi'

/**
 * Product API hook — wraps callProductApi with loading, error, and 401 logout handling.
 */
const useFetch = () => {
  const { config } = useProductConfig()
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const apiRequest = useCallback(
    (operation, input, { onSuccess = () => {}, onError = () => {} } = {}) => {
      setLoading(true)
      callProductApi(config, operation, input)
        .then(result => {
          setData(result)
          onSuccess(result)
        })
        .catch(err => {
          const { handled, error: apiError } = handleApiError(err, config, { operation })
          if (handled) return
          onError(apiError)
          setError(apiError)
        })
        .finally(() => {
          setLoading(false)
        })
    },
    [config]
  )

  return { data, loading, error, apiRequest }
}

export default useFetch
